/**
 * @fileoverview MIME type constants for appointment registration document uploads.
 */

export const MIME_PDF = "application/pdf";
export const MIME_DOCX =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const MIME_JPEG = "image/jpeg";
export const MIME_JPG = "image/jpg";
export const MIME_PNG = "image/png";

export const DOCUMENT_ONLY_MIME_TYPES = [MIME_PDF, MIME_DOCX];

export const PDF_AND_IMAGE_MIME_TYPES = [
  MIME_PDF,
  MIME_JPEG,
  MIME_JPG,
  MIME_PNG,
];
